import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '@/app/layout/MobileNav.css';

/**
 * Tab definition for the mobile bottom navigation.
 */
interface MobileTab {
  readonly to: string;
  readonly icon: string;
  readonly labelKey: string;
}

const MOBILE_TABS: readonly MobileTab[] = [
  { to: '/', icon: 'space_dashboard', labelKey: 'nav.dashboard' },
  { to: '/chart', icon: 'bar_chart_4_bars', labelKey: 'nav.chart' },
  { to: '/positions', icon: 'pin_drop', labelKey: 'nav.positions' },
  { to: '/members', icon: 'group', labelKey: 'nav.members' },
  { to: '/settings', icon: 'settings', labelKey: 'nav.settings' },
  { to: '/info', icon: 'info', labelKey: 'nav.info' },
];

/**
 * Bottom tab bar for mobile viewports (<840px).
 * Shows 5 primary navigation destinations with icon + label.
 */
function MobileNav() {
  const { t } = useTranslation('common');

  return (
    <nav className="mobile-nav" aria-label={t('nav.mainNavigation')}>
      {MOBILE_TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === '/'}
          className={({ isActive }) =>
            `mobile-nav-tab${isActive ? ' mobile-nav-tab-active' : ''}`
          }
        >
          <span className="mobile-nav-icon-wrapper">
            <span className="material-symbols-rounded mobile-nav-icon" aria-hidden="true">
              {tab.icon}
            </span>
          </span>
          <span className="mobile-nav-label">{t(tab.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export { MobileNav };
